import {emojiDefinitions, emojiImageSource} from '../helper/emoji';
import {InputRule} from 'prosemirror-inputrules';
import AbstractNode from './AbstractNode';

export default class Emoji extends AbstractNode {
    get name() {
        return "emoji";
    }

    get schema() {
        return {
            group: "inline",
            attrs: {
                class: {default: 'emoji'},
                src: {},
                alt: {default: null}
            },
            selectable: true,
            draggable: true,
            inline: true,
            parseDOM: [{
                tag: 'img.emoji', getAttrs: token => {
                    return {
                        src: token.getAttribute("src"),
                        alt: token.getAttribute("alt")
                    }
                }
            }],
            toDOM: node => ["img", {
                ...node.attrs,
                class: 'emoji'
            }]
        }
    }

    get parseMarkdown() {
        return {
            node: "emoji",
            noCloseToken: true,
            getAttrs: token => ({
                class: 'emoji',
                src: emojiImageSource(token.content),
                alt: token.content
            })
        };
    }

    toMarkdown(state, node) {
        const emojiDefinition = emojiDefinitions.find(emojiDefinition => emojiDefinition.emoji === node.attrs.alt);
        if (emojiDefinition) {
            state.write(`:${emojiDefinition.aliases[0]}:`);
        }
    }

    inputRules({type}) {
        return [
            new InputRule(/(?::)([a-z_+\-0-9]+):$/, function (state, match, start, end) {
                const [okay, markup] = match;
                const {tr} = state;
                const emojiDefinition = emojiDefinitions.find(emojiDefinition => emojiDefinition.aliases.includes(markup));

                if (okay && emojiDefinition) {
                    tr.replaceWith(start, end, type.createAndFill({
                        src: emojiImageSource(emojiDefinition.emoji),
                        alt: emojiDefinition.emoji
                    }));
                } else {
                    tr.insertText(okay, start, end);
                }

                return tr;
            })
        ];
    }

    commands({schema}) {
        return {
            triggerEmoji: () => view => {
              view.dispatch(view.state.tr.replaceSelectionWith(view.state.schema.text(':')).scrollIntoView());
            }
        };
    }
}